export enum PaymentRequestStatus {
  COMPLETED = "COMPLETED",
  PENDING_INTEGRATION = "PENDING_INTEGRATION",
  PROCESSING = "PROCESSING",
  REFUNDED = "REFUNDED",
  REFUND_REQUESTED = "REFUND_REQUESTED",
  EXPIRED = "EXPIRED",
  REFUND_NOT_MADE = "REFUND_NOT_MADE",
  REFUNDED_PARTIAL = "REFUNDED_PARTIAL",
  CANCELED = "CANCELED",
  WAITING_REFUND_REQUEST = "WAITING_REFUND_REQUEST"
}

enum PaymentRequestTypes {
  ASSOCIATION = "ASSOCIATION",
  MONTHLY = "MONTHLY",
  SETUP = "SETUP",
  SETUP_WITH_ASSOCIATION = "SETUP_WITH_ASSOCIATION"
}

export enum PaymentRequestTypeProviders {
  PIX = "PIX",
  CREDIT_CARD = "CREDIT_CARD",
  INVOICE_DEBIT = "INVOICE_DEBIT"
}

export interface PaymentRequest {
  id: number;
  status: boolean;
  contractId: number;
  requestStatus: PaymentRequestStatus;
  value: number;
  transactionId: string;
  typeProvider: PaymentRequestTypeProviders;
  code: string;
  type: PaymentRequestTypes;
  expiresAt: Date;
  refundedAt?: Date;
  completedAt?: Date;
  billerMetadata?: PaymentRequestBillerMetadata;
}

interface PaymentRequestReceivable {
  uuid: string;
  amount: number;
  service: BillerReceivableService;
}

interface PaymentRequestBillerMetadata {
  receivables: PaymentRequestReceivable[];
}

enum BillerReceivableService {
  ASSOCIATION = "ASSOCIATION",
  ADDITIONAL_SERVICES_PURCHASE = "ADDITIONAL_SERVICES_PURCHASE",
  SETUP_FEE = "SETUP_FEE"
}
